const COLLECTOR_SRC = 'https://reviewcollection.trustpilot.com/verifiedreviewcollector/main.js';

/** Nom du custom element défini par le script Trustpilot. */
export const TRUSTPILOT_COLLECTOR_TAG = 'trustbox-verified-review-collector';

/** Le script est servi par un domaine tiers que Brave et les bloqueurs coupent :
 *  sans plafond, `whenDefined` ne se résout jamais et la modale resterait vide. */
const DEFINITION_TIMEOUT_MS = 8_000;

let collectorPromise: Promise<void> | null = null;

export function loadTrustpilotCollector(): Promise<void> {
  if (collectorPromise) return collectorPromise;

  if (typeof window === 'undefined' || !window.customElements) {
    return Promise.reject(new Error('customElements unavailable'));
  }

  if (window.customElements.get(TRUSTPILOT_COLLECTOR_TAG)) {
    collectorPromise = Promise.resolve();
    return collectorPromise;
  }

  const script = document.createElement('script');
  script.src = COLLECTOR_SRC;
  script.async = true;

  collectorPromise = new Promise<void>((resolve, reject) => {
    const timeoutId = setTimeout(
      () => fail(new Error('Trustpilot collector timed out')),
      DEFINITION_TIMEOUT_MS,
    );

    function fail(error: Error) {
      clearTimeout(timeoutId);
      // Une balise en échec resterait retrouvée par la tentative suivante, qui n'en créerait pas
      // de nouvelle et réattendrait dans le vide : on la retire pour rendre le retry effectif.
      script.remove();
      collectorPromise = null;
      reject(error);
    }

    script.onerror = () => fail(new Error('Trustpilot collector failed to load'));

    void window.customElements.whenDefined(TRUSTPILOT_COLLECTOR_TAG).then(() => {
      clearTimeout(timeoutId);
      resolve();
    });

    document.head.appendChild(script);
  });

  return collectorPromise;
}
